module.exports = __webpack_public_path__ + "img/impresiones.8d6f4831.svg";